import React, { useEffect, useMemo, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaPen, FaPlus, FaSearch } from 'react-icons/fa';
import ErpTemplate from '../../components/ErpTemplate';
import api from '../../services/api';
import '../../css/financeiro-parcela-pagar.css';

export default function PainelParticipanteCategoria() {
    const token = localStorage.getItem('token');
    const [filtro, setFiltro] = useState({ nome: '', buscando: false });
    const [participanteCategorias, setParticipanteCategorias] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const controllerRef = useRef(null);

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setFiltro((state) => ({ ...state, buscando: true }));
        api({
            method: 'get',
            action: '/participanteCategoria',
            token,
            params: filtro,
            signal: controllerRef.current.signal
        })
            .then((response) => {
                setParticipanteCategorias(response.data.data ?? []);
                setPage(1);
                setFiltro((state) => ({ ...state, buscando: false }));
            })
            .catch((err) => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                setFiltro((state) => ({ ...state, buscando: false }));
            });
    };

    useEffect(() => {
        document.querySelector('#nome')?.focus();
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
        // eslint-disable-next-line
    }, []);

    const paginados = useMemo(() => {
        const inicio = (page - 1) * pageSize;
        return participanteCategorias.slice(inicio, inicio + pageSize);
    }, [participanteCategorias, page, pageSize]);

    const totalPaginas = Math.max(1, Math.ceil(participanteCategorias.length / pageSize));

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Categorias</h1>
                        <p className="fin-pp__subtitle">Cadastro auxiliar de categorias de fornecedor no mesmo padrão visual do hub.</p>
                    </div>
                    <div className="fin-pp__actions">
                        <Link to="/cadastroParticipanteCategoria" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill">
                            <FaPlus size={14} /> Nova Categoria
                        </Link>
                    </div>
                </div>

                <form
                    className="fin-pp__card fin-pp__search"
                    style={{ marginBottom: 16, padding: '12px 16px' }}
                    onSubmit={(e) => { buscar(); e.preventDefault(); }}
                >
                    <div className="fin-pp__search-field">
                        <FaSearch className="fin-pp__search-ic" size={16} />
                        <input
                            id="nome"
                            className="fin-pp__input"
                            type="text"
                            placeholder="Buscar pelo nome da categoria"
                            value={filtro.nome ?? ''}
                            onChange={(e) => setFiltro((state) => ({ ...state, nome: e.target.value }))}
                        />
                    </div>
                    <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={filtro.buscando}>
                        {filtro.buscando ? 'Buscando...' : 'Buscar'}
                    </button>
                </form>

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ minWidth: 720, tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 62 }}></th>
                                    <th style={{ width: 100 }}>Código</th>
                                    <th>Nome</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtro.buscando ? (
                                    <tr><td colSpan={3} className="fin-pp__empty"><span className="fin-pp__loading"><span className="fin-pp__spin"></span>Buscando...</span></td></tr>
                                ) : paginados.length === 0 ? (
                                    <tr><td colSpan={3} className="fin-pp__empty">Nenhum registro</td></tr>
                                ) : paginados.map((row) => (
                                    <tr key={row.id}>
                                        <td>
                                            <Link to={`/cadastroParticipanteCategoria/${row.id}`} className="fin-pp__rowbtn" title="Alterar categoria">
                                                <FaPen size={14} />
                                            </Link>
                                        </td>
                                        <td className="fin-pp__cell-muted">{row.codigo ?? ''}</td>
                                        <td className="fin-pp__cell-strong">{row.nome ?? ''}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{participanteCategorias.length} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <select
                                className="fin-pp__select"
                                style={{ height: 34 }}
                                value={pageSize}
                                onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                    setPage(1);
                                }}
                            >
                                <option value={15}>15 / pág</option>
                                <option value={30}>30 / pág</option>
                                <option value={50}>50 / pág</option>
                            </select>
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage((state) => state - 1)}>
                                Anterior
                            </button>
                            <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                            <button type="button" className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage((state) => state + 1)}>
                                Próxima
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
